document.addEventListener('DOMContentLoaded', function () {
  function initializeTimer(endTime, timerId) {
    var second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;
    var countDown = new Date(endTime).getTime();

    function padNumber(number) {
      return Math.max(0, number).toString().padStart(2, '0');
    }

    function updateTimer() {
      var now = new Date().getTime(),
        distance = countDown - now;

      var timerElement = document.getElementById('timer-' + timerId);

      if (distance < 0) {
        clearInterval(timerInterval);
        timerElement.remove();
        return;
      }

      // Set background color based on remaining time
      if (distance <= hour) {
        timerElement.style.backgroundColor = '#ca3231';
      } else if (distance <= 2 * hour) {
        timerElement.style.backgroundColor = '#ffa411';
      } else if (distance <= 3 * hour) {
        timerElement.style.backgroundColor = '#e9bb39';
      } else {
        timerElement.style.backgroundColor = '#4d8ea9'; // Default color
      }

      timerElement.querySelector('.js-timer-days').innerText = padNumber(Math.floor(distance / day));
      timerElement.querySelector('.js-timer-hours').innerText = padNumber(Math.floor((distance % day) / hour));
      timerElement.querySelector('.js-timer-minutes').innerText = padNumber(Math.floor((distance % hour) / minute));
      timerElement.querySelector('.js-timer-seconds').innerText = padNumber(Math.floor((distance % minute) / second));
    }

    var timerInterval = setInterval(updateTimer, second);
    updateTimer();
  }

  function initializeAllTimers() {
    document.querySelectorAll('[data-timer-id]').forEach(function (element) {
      var timerId = element.getAttribute('data-timer-id');
      var endTime = element.getAttribute('data-end-time');
      if (!element.getAttribute('data-initialized')) {
        element.setAttribute('data-initialized', 'true');
        initializeTimer(endTime, timerId);
      }
    });
  }

  // Initialize all timers on page load
  initializeAllTimers();

  // Monitor for dynamically added timers using MutationObserver
  var observer = new MutationObserver(function () {
    initializeAllTimers();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});